module.exports = __webpack_public_path__ + "static/img/main-navigation-icon05.6e8064ba.svg";